import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import {
  Settings,
  ExpandMore
} from '@mui/icons-material';
import { Redirect } from '../../utils/link';


const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing(2)
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 700
  }
});

class ClonePlacementForm extends Component {

  render() {
    const {
      classes,
      placement,
      onChange,
      maxCopies,
      cloneSettings
    } = this.props;

    const { copies,
      agencyPlacementName,
      agencyPlacementId,
      billingGroup,
      dates,
      errors
    } = cloneSettings;

    return (
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Settings className={classes.leftIcon} />
          <Typography variant="h6">
              Clone <Redirect
                to={`/ios/${placement.ioId}/placements/${placement.id}`}
                className={classes.link}
                value={placement.agencyPlacementName}
              />
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3} direction="row">
            <Grid item xs={6}>
              <TextField
                variant="standard"
                name="copies"
                value={copies}
                label={`Number of Copies up to ${maxCopies}`}
                type="Number"
                onChange={onChange}
                error={!!errors.copies}
                helperText={errors.copies}
                fullWidth />
            </Grid>
            <Grid item xs={6} />

            <Grid item xs={6}>
              <TextField
                variant="standard"
                name="agencyPlacementName.base"
                value={agencyPlacementName.base}
                label="Agency Placement Name (Base)"
                onChange={onChange}
                fullWidth
                error={!!errors.agencyPlacementName}
                helperText={errors.agencyPlacementName} />
            </Grid>

            <Grid item xs={2}>
              <FormControlLabel
                control={(
                  <Switch
                    checked={agencyPlacementName.increment}
                    onChange={onChange}
                    id="agencyPlacementName.increment"
                    color="primary"
                  />
                )}
                label="Increment"
              />
            </Grid>
            {agencyPlacementName.increment && (
            <Grid item xs={3}>
              <TextField
                variant="standard"
                name="agencyPlacementName.start"
                value={agencyPlacementName.start}
                label="Start"
                onChange={onChange}
                error={!!errors.agencyPlacementName}
                type="Number" />
            </Grid>
            )}

            <Grid item xs={6}>
              <TextField
                variant="standard"
                name="agencyPlacementId.base"
                value={agencyPlacementId.base}
                label="Agency Placement Id (Base)"
                onChange={onChange}
                error={!!errors.agencyPlacementId}
                helperText={errors.agencyPlacementId}
                fullWidth
                margin="normal" />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={(
                  <Switch
                    checked={agencyPlacementId.increment}
                    onChange={onChange}
                    id="agencyPlacementId.increment"
                    color="primary"
                  />
                )}
                label="Increment"
              />
            </Grid>
            {agencyPlacementId.increment && (
            <Grid item xs={3}>
              <TextField
                variant="standard"
                name="agencyPlacementId.start"
                value={agencyPlacementId.start}
                label="Start"
                onChange={onChange}
                error={!!errors.agencyPlacementId}
                type="Number" />
            </Grid>
            )}

            <Grid item xs={6}>
              <TextField
                variant="standard"
                name="billingGroup.base"
                value={billingGroup.base}
                label="Billing Group (Base)"
                onChange={onChange}
                error={!!errors.billingGroup}
                helperText={errors.billingGroup}
                fullWidth
                margin="normal" />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                control={(
                  <Switch
                    checked={billingGroup.increment}
                    onChange={onChange}
                    id="billingGroup.increment"
                    color="primary"
                  />
                )}
                label="Increment"
              />
            </Grid>
            {billingGroup.increment && (
            <Grid item xs={3}>
              <TextField
                variant="standard"
                name="billingGroup.start"
                value={billingGroup.start}
                label="Start"
                onChange={onChange}
                error={!!errors.billingGroup}
                type="Number" />
            </Grid>
            )}
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <InputLabel htmlFor="dates.base">Adjustment Period</InputLabel>
                <Select
                  variant="standard"
                  native
                  value={dates.base}
                  onChange={onChange}
                  inputProps={{
                    name: 'dates.base',
                    id: 'dates.base'
                  }}>
                  <option value="no-adjustment">No Date Adjustment</option>
                  <option value="month">Start/End of next month</option>
                  <option value="quarter">Start/End of next quarter</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <Tooltip title={dates.base === 'no-adjustment' ? 'you must choose a date adjust type first' : ''}>
                <FormControlLabel
                  control={(
                    <Switch
                      checked={dates.increment}
                      onChange={onChange}
                      id="dates.increment"
                      color="primary"
                      disabled={dates.base === "no-adjustment"}
                    />
                  )}
                  label="Increment"
                />
              </Tooltip>
            </Grid>
            {dates.increment && (
            <Grid item xs={3}>
              <TextField
                variant="standard"
                name="dates.start"
                value={dates.start}
                label="Start"
                onChange={onChange}
                error={!!errors.billingGroup}
                type="Number" />
            </Grid>
            )}

          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}

ClonePlacementForm.propTypes = {
  classes: PropTypes.object.isRequired,
  placement: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  maxCopies: PropTypes.number.isRequired,
  cloneSettings: PropTypes.object.isRequired
};

export default withStyles(styles)(ClonePlacementForm);
